module.exports = __webpack_public_path__ + "4f50fe88b64fe3c057fde7a32452abe1.fbx";